import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Helmet from "react-helmet";
import Section from "Components/Section";
import Loader from "Components/Loader";
import Message from "Components/Message";
import Poster from "Components/Poster";

const Container = styled.div`
    padding:20px;
`;

const TVPresenter = ({ topRated, popular, airingToday, loading, error }) => (
    <>
        <Helmet><title>TV Shows | Beomflix</title></Helmet>
        {loading ? (<Loader />) :
            <Container>
                {/* <Helmet><title>TV Shows | Beomflix</title></Helmet> */}
                {topRated && topRated.length > 0 && (
                    <Section title="Top Rated TV Shows">
                        {topRated.map(show => (
                            <Poster
                                key={show.id}
                                id={show.id}
                                title={show.original_name}
                                imageUrl={show.poster_path}
                                rating={show.vote_average}
                                year={show.first_air_date && show.first_air_date.substring(0, 4)}
                                isMovie={false}

                            />))}
                    </Section>
                )}
                {popular && popular.length > 0 && (
                    <Section title="Popular TV Shows">
                        {popular.map(show => (
                            <Poster
                                key={show.id}
                                id={show.id}
                                title={show.original_name}
                                imageUrl={show.poster_path}
                                rating={show.vote_average}
                                year={show.first_air_date && show.first_air_date.substring(0, 4)}
                                isMovie={false}

                            />))}
                    </Section>
                )}
                {airingToday && airingToday.length > 0 && (
                    <Section title="Airing Today TV Shows">
                        {airingToday.map(show => (
                            <Poster
                                key={show.id}
                                id={show.id}
                                title={show.original_name}
                                imageUrl={show.poster_path}
                                rating={show.vote_average}
                                year={show.first_air_date && show.first_air_date.substring(0, 4)}
                                isMovie={false}

                            />))}
                    </Section>
                )}
                {error && <Message color="#e74c3c" text={error} />}
            </Container>}
    </>
);
TVPresenter.propTypes = {
    topRated: PropTypes.array,
    popular: PropTypes.array,
    airingToday: PropTypes.array,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string
}


export default TVPresenter;